/* globals lp, jui,Class */
module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.ModuleComponent,
  {
    type:'lp-pom-video',

     initialize: function($super) {
        $super();
      },

      installUI: function($super){
        $super();
        var self = this;

        this._uiBinding.subscribeDomainEvents(this.domainEvents, this);

        var editButtonPanel = this.insert(new jui.CollapsiblePanel({
          attributes: {
            className: 'collapsible-panel panel-video-edit no-label'
          }
        }));
        
        editButtonPanel.e.style.borderTop = 'none';
        editButtonPanel.titleBar.hide();
        this.controls.editButton = editButtonPanel.insertContent(new jui.Button({
          classNames : ['full-width-button'],
          label      : 'Edit Code',
          action     : function(){
            self._uiBinding.onNext({
              type: 'editVideo'
            });
          }
        }));

        var geometryPanel = this.insert(
          new jui.CollapsiblePanel({
            title:'Geometry',
            attributes  : {
              className : 'collapsible-panel panel-video-geometry'
            }
          })
        );

        this.installGeometryControls({
          insert:geometryPanel.insertContent.bind(geometryPanel),
          sizeOptions: {
            showMaintainAR: true,
            minWidth: 10,
            minHeight: 10
          }
        });
      },

      syncUIControls: function($super, elm) {
        $super(elm);
        this.bindGeometryControlsToElement(elm);
        var m   = elm.model;

        if(m.exists('geometry.aspectRatio')) {
          this.controls.size.setAspectRatio(m.get('geometry.aspectRatio'));
          this.controls.size.setMaintainAspectRatio(m.get('geometry.maintainAR'));
        }
      },

      domainEvents: {
        editVideo: function() {
          var self = this;
          this.getModule().openBuilder(this.element, {
            callback: function(data) {
              self.element.model.set(
                'content.html', data.html, self.element.page.undoManager
              );
            }
          });
        }
      }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-video/video_element_properties_panel.js
// module id = 1481
// module chunks = 0